const DEVICE_ID_KEY = 'm2mba_device_id'

function createDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `dev-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}

/** Stable per-browser device id persisted in localStorage */
export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY)
    if (existing && existing.length >= 8) return existing
    const next = createDeviceId()
    localStorage.setItem(DEVICE_ID_KEY, next)
    return next
  } catch {
    return createDeviceId()
  }
}

/** Persist canonical device id returned by server (fingerprint reuse). */
export function setDeviceId(deviceId: string): void {
  if (!deviceId || deviceId.length < 8) return
  try {
    localStorage.setItem(DEVICE_ID_KEY, deviceId)
  } catch {
    /* ignore quota / private mode */
  }
}

export function getDeviceLabel(): string {
  try {
    const ua = navigator.userAgent || ''
    if (/Mobile|Android|iPhone|iPad/i.test(ua)) return 'Mobile'
    return 'Desktop'
  } catch {
    return 'Unknown'
  }
}
